module.exports = __webpack_public_path__ + "static/media/generation-primary.579019a5.jpg";